// extracted by mini-css-extract-plugin
export default {"products":"Products_products__0XXxz","card":"Products_card__5k36U"};